import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import { UserMedicineHistoryModel } from '../../../models/user/userMedicineHistoryModel';
import UserService from '../../../services/userService';
import Translate from '../../../common/functions/translate';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { UserNotificationModel } from "../../../models/user/userNotificationModel";
import UserNotificationAddEditDialog from './userNotificationAddEditDialog'
import { NotificationScheduleType, NotificationAlarmType } from "../../../common/enums";
import { fomatDateTimeAsString, getNotificationSummary, fomatDateAsString, fomatTimeAsString } from '../../../common/functions/helperFunctions';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import Spinner from '../../../common/components/spinner/spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import Switch from '@material-ui/core/Switch';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import Button from '@material-ui/core/Button';
import * as Constants from '../../../common/constants'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Growl from '../../../common/components/alertMessage/growl';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { connect } from 'react-redux';
import * as actionTypes from '../../../store/actionTypes';
import { NotificationSchedulerModel } from '../../../models/notificationSchedulerModel';

const materialTheme = createMuiTheme({
  overrides: {
    MuiSwitch: {
      switchBase: {
        height: '26px'
      },
    },
  },
  palette: {
    primary: blue,
  },
});

interface IProps {
  isVisible: boolean,
  closeClick: any,
  userMedicineHistoryId: number,
  lang: string
}

interface IState {
  isLoading: boolean;
  validationMessage: string;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  currentMedicineHistory: UserMedicineHistoryModel;
  isVisibleNotificationAddEditDDialog: boolean,
  currrentUserNotification: UserNotificationModel,
  isVisibleConfirmDialog: boolean;
  isActivePushNotifications: boolean,
  isVisibleNotificationConfirm: boolean,
  newUserNotification: UserNotificationModel
}

const initFrom = 0;
const numberOfRows = 10;

class UserNotificationListDialog extends React.Component<IProps, IState> {
  userService = new UserService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      validationMessage: '',
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      currentMedicineHistory: new UserMedicineHistoryModel(),
      isVisibleNotificationAddEditDDialog: false,
      currrentUserNotification: new UserNotificationModel(),
      isVisibleConfirmDialog: false,
      isActivePushNotifications: false,
      isVisibleNotificationConfirm: false,
      newUserNotification: new UserNotificationModel()
    }
  }

  componentDidMount() {
    this.getMedicineNotifications(this.props.userMedicineHistoryId)
  }

  setCurrentMedicineHistory(currentMedicineHistory: UserMedicineHistoryModel) {
    this.setState({ currentMedicineHistory: { ...currentMedicineHistory } });
  }

  getMedicineNotifications = (userMedicineHistoryId) => {
    if (!userMedicineHistoryId) {
      this.growl.show({ severity: 'error', summary: "MedicneID not valid" });
    } else {
      this.setState({
        isLoading: true
      });
      this.userService.getHistoryNotifications(userMedicineHistoryId, this.props.lang)
        .then(
          (data: UserMedicineHistoryModel) => {
            this.setCurrentMedicineHistory(data);
            this.setState({
              isLoading: false
            });
            this.userHasPushSubscription();
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    }
  }

  handleCloseButton = () => {
    this.props.closeClick();
  }

  showUserNotificationDialog = (show: boolean) => {
    this.setState({
      isVisibleNotificationAddEditDDialog: show
    });
  }

  handleUserNotificationAddClick = () => {
    let theNextHour: Date = new Date();
    theNextHour.setHours(theNextHour.getHours() + 1, 0)
    let newUserNotification = new UserNotificationModel();
    newUserNotification.isSingleDailyOccurance = true;
    newUserNotification.isActive = true;
    newUserNotification.notificationScheduleTypeId = 1;
    newUserNotification.notificationAlarmTypeId = 2;
    newUserNotification.notificationFrequencyId = 2;
    newUserNotification.notificationFrequencyCounter = 1;
    newUserNotification.userMedicineHistoryId = this.state.currentMedicineHistory.userMedicineHistoryId;
    newUserNotification.userId = this.state.currentMedicineHistory.userId;
    newUserNotification.timeZoneOffsetInMinutes = (new Date()).getTimezoneOffset();

    newUserNotification.alarmTime = theNextHour.toUTCString();
    newUserNotification.oneTimeExecutionDate = theNextHour.toUTCString();

    // let netificationStartDate = this.state.currentMedicineHistory.startDate;
    // if (netificationStartDate) {
    //   newUserNotification.startDate = fomatDateTimeAsString(new Date(fomatDateAsString(new Date(netificationStartDate)) + " " + fomatTimeAsString(new Date())));
    // } else {
    //   newUserNotification.startDate = new Date().toUTCString();
    // }

    // if (this.state.currentMedicineHistory.endDate) {
    //   newUserNotification.endDate = new Date(this.state.currentMedicineHistory.endDate).toUTCString();
    // } else {
    //   newUserNotification.endDate = new Date().toUTCString();
    // }

    // newUserNotification.startTime = fomatDateTimeAsString(new Date(fomatDateAsString(new Date(newUserNotification.startDate)) + " 00:00:00"));
    // newUserNotification.endTime = fomatDateTimeAsString(new Date(fomatDateAsString(new Date(newUserNotification.startDate)) + " 23:59:59"));

    this.setState({
      currrentUserNotification: newUserNotification,
      isVisibleNotificationAddEditDDialog: true
    });
  }

  handleUserNotificationDialogCancelButton = () => {
    this.setState({
      isVisibleNotificationAddEditDDialog: false
    });
  }

  userHasPushSubscription() {
    navigator.serviceWorker.getRegistration().then((registration: any) => {
      if (registration) {
        registration.pushManager.getSubscription()
          .then(subscription => {
            if (subscription) {
              this.setState({
                isActivePushNotifications: true
              });
            }
          });
      }
    });
  }

  subscribeForPushNotifications() {
    this.setState({ isVisibleNotificationConfirm: false });

    const pushIsSupported: boolean = 'serviceWorker' in navigator && 'PushManager' in window;

    if (!pushIsSupported)
      return;

    let applicationServerPublicKey = HelperFunctions.urlB64ToUint8Array(Constants.applicationServerPublicKey);
    navigator.serviceWorker.getRegistration()
      .then((registration: any) => {
        if (registration) {
          registration.pushManager.getSubscription()
            .then(subscription => {
              if (subscription) {
                // subscription present, no need to register subscription again
                this.growl.show({ severity: 'success', summary: Translate('You have already subscribed for Notifications.') });
                this.setState({
                  isLoading: false
                });
                return;
              }

              registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: applicationServerPublicKey
              })
                .then(subscription => {
                  this.userService.createPushSubscription(subscription)
                    .then((data: any) => {
                      if (data) {
                        this.setState({
                          isActivePushNotifications: true,
                          isLoading: false
                        });
                        this.growl.show({ severity: 'success', summary: Translate('You have successfully subscribed for Notifications.') });
                      }
                    })
                    .catch(error => this.catchErrorFailedToSubscribe(error));
                })
                .catch(error => this.catchErrorFailedToSubscribe(error));
            })
            .catch(error => this.catchErrorFailedToSubscribe(error));
        } else {
          this.catchErrorFailedToSubscribe({ message: '' })
        }
      });
  }

  catchErrorFailedToSubscribe = (error) => {
    this.setState({
      isLoading: false
    });
    this.growl.show({ severity: 'error', summary: Translate('Failed to subscribe for Push Notifications:') + error.message });
  }

  handleUserNotificationAddDialogSaveButton = (userNotification: UserNotificationModel) => {
    this.showUserNotificationDialog(false);
    this.setState({
      isLoading: true
    });

    const currentMedicineHistory: UserMedicineHistoryModel = { ...this.state.currentMedicineHistory };

    if (!userNotification.userNotificationId) {
      this.userService.addNotification(userNotification, this.props.lang)
        .then(
          (data) => {
            this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.getMedicineNotifications(currentMedicineHistory.userMedicineHistoryId);
            if (userNotification.notificationAlarmTypeId == NotificationAlarmType.PushNotification && !this.state.isActivePushNotifications) {
              this.setState({
                isVisibleNotificationConfirm: true,
                newUserNotification: { ...userNotification }
              });
            }
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    } else {
      this.growl.show({ severity: 'error', summary: "EROR in save button" });
      this.setState({
        isLoading: false
      });
    }

  }

  handleNotificationActivationButton = (userNotification: UserNotificationModel, isActive: boolean) => {
    const currentMedicineHistory: UserMedicineHistoryModel = { ...this.state.currentMedicineHistory };

    if (userNotification && userNotification.userNotificationId > 0) {
      this.userService.updateNotification(userNotification.userNotificationId, isActive)
        .then(
          (data) => {
            this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.getMedicineNotifications(currentMedicineHistory.userMedicineHistoryId);
            if (userNotification.notificationAlarmTypeId == NotificationAlarmType.PushNotification && !this.state.isActivePushNotifications && isActive) {
              this.setState({
                isVisibleNotificationConfirm: true,
                newUserNotification: { ...userNotification }
              });
            }
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    } else {
      this.growl.show({ severity: 'error', summary: "EROR in active/deactive button" });
      this.setState({
        isLoading: false
      });
    }
    this.showUserNotificationDialog(false);
  }

  handleNotificationDeleteClick = (event, userNotificationId) => {
    event.preventDefault();
    let userNotification = this.state.currentMedicineHistory.userNotifications.find(m => m.userNotificationId === userNotificationId);
    if (userNotification) {
      this.setState({
        currrentUserNotification: userNotification
      });
    }
    this.setState({
      isVisibleConfirmDialog: true
    });
  }

  deleteNotification = (userNotificationId) => {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    if (userNotificationId) {
      this.userService.deleteNotification(userNotificationId)
        .then(
          (data) => {
            this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
            this.getMedicineNotifications(this.state.currentMedicineHistory.userMedicineHistoryId);
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    }
    else {
      this.growl.show({ severity: 'error', summary: "Delete failed" });
      this.setState({
        isLoading: false
      });
    }
  }

  render() {
    const { currentMedicineHistory, currrentUserNotification, isLoading } = this.state;

    let dialogHeader: string = Translate('Alarms');
    let contentHeader = Translate('Alarms') + " " + Translate('for') + " " + Translate('medicine')
      + " " + ((currentMedicineHistory && currentMedicineHistory.medicineName) ? currentMedicineHistory.medicineName : "");

    return (
      <>
        <Dialog
          open={this.props.isVisible}
          onClose={this.handleCloseButton}
          fullWidth
        >
          <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCloseButton}>{dialogHeader}</Modal.DialogTitle>
          <Modal.DialogContent>
            <div>
              <Growl ref={(el) => this.growl = el} />
              {isLoading ? <Spinner /> : null}
              {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
              <h4>{contentHeader}</h4>
              <div className="p-grid p-fluid p-md-12">
                <div style={{ marginBottom: 10, width: '100%', textAlign: "right" }}>
                  <Fab color="primary" aria-label="Add" size="small" onClick={() => this.handleUserNotificationAddClick()}>
                    <AddIcon />
                  </Fab>
                </div>
                <ul className="list-items" style={{ width: '100%' }}>
                  {currentMedicineHistory.userNotifications ?
                    currentMedicineHistory.userNotifications.map((m: UserNotificationModel) =>
                      <li key={m.userNotificationId + 'uNotId'}>
                        <div className="item-info">
                          <div className="item-name">
                            {m.notificationScheduleTypeId ? HelperFunctions.getEnumLabel(m.notificationScheduleTypeId, NotificationScheduleType, true) + " " : null}
                            ({m.notificationAlarmTypeId ? HelperFunctions.getEnumLabel(m.notificationAlarmTypeId, NotificationAlarmType, true) : null})
                              {m.canBeActivated ? <FormControlLabel
                              control={
                                <Switch
                                  checked={m.isActive}
                                  onChange={(e) => this.handleNotificationActivationButton(m, e.target.checked)}
                                  value="checkedB"
                                  color="primary"
                                />
                              }
                              label={m.isActive ? Translate('ActiveА') : Translate('NotActive')}
                            /> : null}
                          </div>
                          <div className="item-desc">
                            {getNotificationSummary(m, this.props.lang)}
                            {m.caretakerUserId && m.caretakerUserId > 0 ?
                              <div>
                                {Translate("SendNotificationsTo") + " "}<span style={{ fontWeight: 600 }}>{m.caretakerName}</span>{" " + Translate("InCaseThat") + " "}
                                <span style={{ fontWeight: 600 }}>{m.minutesForIntake}</span> {" " + Translate("Minutes")}
                              </div>
                              : null}
                          </div>
                        </div>
                        <div className="item-actions">
                          <a href='' onClick={(e) => this.handleNotificationDeleteClick(e, m.userNotificationId)} title={Translate('Remove')} >
                            <FontAwesomeIcon icon={faTimesCircle} style={{ color: '#f50057', fontSize: '1.3em', margin: '0 2px' }} />
                          </a>
                        </div>
                      </li>
                    ) : null}
                  {!isLoading && (!currentMedicineHistory.userNotifications || currentMedicineHistory.userNotifications.length == 0) ? Translate("No records found") : null}
                </ul>
              </div>
            </div>
          </Modal.DialogContent>
          <Modal.DialogActions>
            <div>
              <Button variant="contained" size="small" onClick={this.handleCloseButton}>
                <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                {Translate('Close')}
              </Button>
            </div>
          </Modal.DialogActions>
        </Dialog>
        {this.state.isVisibleNotificationAddEditDDialog ? (
          <UserNotificationAddEditDialog
            lang={this.props.lang}
            //userMedicineHistoryId={currentMedicineHistory.userMedicineHistoryId}
            selectedUserNotification={this.state.currrentUserNotification}
            saveClick={this.handleUserNotificationAddDialogSaveButton}
            cancelClick={this.handleUserNotificationDialogCancelButton}
            isVisible={this.state.isVisibleNotificationAddEditDDialog}
          />
        ) : null}

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteNotification(currrentUserNotification.userNotificationId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          {Translate("Are you sure that you want to delete this record")}
        </ConfirmDialog>

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleNotificationConfirm}
          yesClick={() => { this.subscribeForPushNotifications() }}
          noClick={() => { this.setState({ isVisibleNotificationConfirm: false }) }}>
          {Translate("Do you want to activate notification on this device")}
        </ConfirmDialog>
      </>
    )
  }
}

export default UserNotificationListDialog;
